module.exports = __webpack_public_path__ + "media/images/reportimages/globe-67ee77bc1342a8d194e51ef166b60506.png";